/* ------------------------------------------------------------------
   SAEGE: Okendo tweaks on the PDP. Loaded from
   snippets/saege-pdp-loader.liquid whenever okendo_reviews is on.

   1. REVIEW TITLES. Every review that came across in the Loox import
      has its own rating as its title - "5 Stars", "1 Star" - so each
      row showed the score twice, once as stars and once in words.
      Those titles are tagged here and hidden by a rule in Okendo's
      Custom CSS (Settings > Custom CSS in the Okendo admin).

      It is done by matching the text rather than hiding every title,
      because reviews collected through Okendo's own form DO ask for a
      title, and a real one written by a customer should still show.
      Checked 11/09/26: of the 100 most recent reviews, 100 were
      rating-derived or empty and none were written by a reviewer.

   2. HEADING. "REVIEWS (1,017)" above the widget, at the same 16px
      uppercase as COMPLETE THE LOOK and PRODUCT DETAILS so the page
      reads as one system. The count comes from the widget's own
      server-rendered JSON, the same source the buy-box rating uses,
      so it is right on first paint with no request of its own.

      Because the heading carries the count, Okendo's own "Based on
      n reviews" line underneath is hidden in assets/saege-okendo.css
      - otherwise the number is stated twice, two lines apart.

      Controlled by okendo_heading in the loader, passed in as
      window.SAEGE_OKENDO.heading.

   Okendo re-renders the list on sort, filter and Show More, so a
   MutationObserver re-applies both after every render.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var CFG = window.SAEGE_OKENDO || {};
  var GENERIC = /^\s*\d\s*stars?\s*$/i;
  var headingDone = false;

  /* Review count from the widget's own server-rendered JSON. */
  function reviewCount() {
    var tags = document.querySelectorAll('[data-oke-metafield-data]');
    for (var i = 0; i < tags.length; i++) {
      var j;
      try { j = JSON.parse(tags[i].textContent); } catch (e) { continue; }
      var agg = j && j.reviewAggregate;
      if (agg && agg.ratingAndReviewCount > 0) return Number(agg.ratingAndReviewCount);
      if (j && j.reviewCount > 0) return Number(j.reviewCount);
    }
    return 0;
  }

  function heading() {
    if (headingDone) return;
    var widget = document.querySelector('.okeReviews.oke-w');
    if (!widget) return;
    var host = widget.closest('.container') || widget.parentElement;
    if (!host) return;

    var n = reviewCount();
    var h = host.querySelector('.saege-okendo-head');

    /* A count of 0 means one of two things: the server-rendered JSON has
       not been read yet, or the product genuinely has no reviews. Both
       are handled the same way - render nothing until the count is
       positive, and take the heading back out if one is already there.
       headingDone stays false, so the observer below keeps retrying and
       a count that arrives later still gets its heading. A bare REVIEWS
       over an empty widget is never shown. */
    if (n <= 0) {
      if (h && h.parentNode) h.parentNode.removeChild(h);
      return;
    }

    var text = 'Reviews (' + n.toLocaleString() + ')';

    if (!h) {
      h = document.createElement('h2');
      h.className = 'saege-shead saege-okendo-head';
      host.insertBefore(h, host.firstChild);
    }
    if (h.textContent !== text) h.textContent = text;

    /* only stop once a real count has been read - the pre-rendered
       markup is server-side, but a re-render can arrive later */
    headingDone = true;
  }

  function titles() {
    var list = document.querySelectorAll('.okeReviews .oke-reviewContent-title');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      var generic = GENERIC.test(el.textContent || '');
      if (generic && !el.hasAttribute('data-saege-generic')) {
        el.setAttribute('data-saege-generic', '1');
      } else if (!generic && el.hasAttribute('data-saege-generic')) {
        el.removeAttribute('data-saege-generic');
      }
    }
  }

  function run() {
    if (CFG.heading) heading();
    titles();
  }

  function start() {
    run();
    var t;
    /* childList only - the attribute writes above must not re-trigger this */
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
